import {useMemo, useState} from 'react'
import {Box, Flex, Table} from '@binance/uikit'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useTransactionHistoryDataProvider from 'hooks/useTransactionHistoryDataProvider'
import useSymbolInfo from 'hooks/useSymbolInfo'
import {getDateRange} from 'utils/common'
import ToolBar from './ToolBar'
import {NoData} from './NoData'

const getTitles = i18n => [
  {
    title: i18n['tradeHistory-timeTitle'] || 'Time',
    key: 'time',
    direction: 'start',
    width: 158
  },
  {
    title: i18n['tradeHistory-typeTitle'] || 'Type',
    key: 'balancetype',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-amountTitle'] || 'Amount',
    key: 'balanceDelta',
    direction: 'start',
    width: 110
  },
  {
    title: i18n['tradeHistory-assetTitle'] || 'Asset',
    key: 'asset',
    direction: 'start',
    width: 110
  }
]

export default function TransactionHistoryPane ({i18n, focus}) {
  const {start, end} = getDateRange()
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)
  const isLogin = useUserLoginStatus()
  const {symbolInfo} = useSymbolInfo()
  const {quoteAsset} = symbolInfo
  const {data = {}, hasMore, loadMore} = useTransactionHistoryDataProvider(
    isLogin,
    quoteAsset,
    startDate,
    endDate,
    focus
  )
  return useMemo(
    () =>
      isLogin ? (
        <Flex width="100%" flexDirection="column">
          <ToolBar
            i18n={i18n}
            activeColor="w"
            handleDateChange={({startTime, endTime}) => {
              setStartDate(startTime)
              setEndDate(endTime)
            }}
          />
          <Box flex={1}>
            <Table
              data={data}
              title={getTitles(i18n)}
              nodata={isLogin ? NoData('transcation history') : null}
              hasMore={hasMore}
              loadMoreRows={loadMore}
            />
          </Box>
        </Flex>
      ) : null,
    [data, hasMore, i18n, isLogin, loadMore]
  )
}
